import React from "react";
const appstore = require('./appstore.svg');

export function AppLink() {
  return <a target="_blank" href="https://apps.apple.com/de/app/anwaltspostfach-bea/id1512806756#?mt=8&platform=iphone">
    <img src={appstore} style={{ height: "40px" }} />
  </a>;
}
